module.exports = __webpack_public_path__ + "img/portrait_photo_example@2x.91f80409.png";